module.exports = __webpack_public_path__ + "static/media/novacancies.0304110f.png";